import { Link } from "react-router-dom";
import { PACK_IMG, shippingLabel } from "@/data/content";
import { bagsOf, isBuilder, money, perBagMoney, useShop } from "@/lib/shop";
import { AddButton } from "./AddButton";
import { Reveal } from "./Reveal";

export const Bundles = () => {
  const { products } = useShop();
  const six = products.filter((p) => bagsOf(p.title) === 6);
  const ref = six.length ? Math.max(...six.map((p) => p.price / 6)) : null;
  const boxes = products.filter(isBuilder).sort((a, b) => bagsOf(a.title) - bagsOf(b.title));
  if (!boxes.length) return null;
  const best = Math.min(...boxes.map((p) => p.price / bagsOf(p.title)));

  return (
    <div id="boxes">
      <Reveal className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-display text-3xl sm:text-4xl">Build your own box</h2>
          <p className="text-[#4A4560] mt-2">Our most popular way to shop. Mix any of the 5 flavours, and the bigger the box, the less you pay per bag.</p>
        </div>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-4">
        {boxes.map((p, i) => {
          const bags = bagsOf(p.title);
          const per = p.price / bags;
          const save = ref ? Math.round((1 - per / ref) * 100) : 0;
          const isBest = per === best;
          return (
            <Reveal key={p.id} delay={i * 0.08} data-testid={`bundle-row-${p.handle}`}
              className={`group relative rounded-[28px] overflow-hidden border flex flex-col ${isBest ? "bg-[#1B1530] text-white border-transparent" : "bg-white border-[#1B1530]/10"}`}>
              {isBest && <span data-testid="best-value-badge" className="absolute top-4 right-4 z-10 rounded-full bg-[#3EE6FF] text-[#1B1530] text-[11px] font-bold uppercase px-3 py-1">Best value</span>}
              {bags === 12 && <span data-testid="most-popular-badge" className="absolute top-4 right-4 z-10 rounded-full bg-[#FFB21A] text-[#1B1530] text-[11px] font-bold uppercase px-3 py-1">Most popular</span>}
              <Link to={`/build?size=${bags}`} data-testid={`bundle-image-link-${p.handle}`} aria-label={`Build your ${bags}-bag box`} className="block aspect-[16/10] overflow-hidden bg-[#BDE3FA] cursor-pointer">
                <img src={PACK_IMG[p.handle] || p.image} alt={`${bags} Swole Bears bags`} loading="lazy" data-testid={`bundle-image-${p.handle}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </Link>
              <Link to={`/build?size=${bags}`} data-testid={`bundle-details-link-${p.handle}`} className="px-6 pt-6 block">
                <p className="font-display text-6xl leading-none">{bags}<span className="text-2xl ml-2">bags</span></p>
              </Link>
              <div className="px-6 pb-6 flex-1 flex flex-col">
                <p className={`text-sm mt-3 ${isBest ? "text-white/80" : "text-[#4A4560]"}`}>{perBagMoney(per)}/bag{save > 0 ? ` · save ${save}% vs 6-packs` : ""}</p>
                {shippingLabel(p.price) && <p data-testid={`bundle-shipping-${p.handle}`} className="mt-2 inline-flex w-fit rounded-full px-3 py-1 text-xs font-bold bg-[#7BD88F] text-[#1B1530]">{shippingLabel(p.price)}</p>}
                <div className="mt-auto pt-6 flex flex-col gap-4">
                  <span data-testid={`bundle-price-${p.handle}`} className="font-display text-3xl">{money(p.price)}</span>
                  <AddButton product={p} testid={`bundle-action-${p.handle}`} className="w-full" />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  );
};
